import { render, staticRenderFns } from "./FieldTransRichText.vue?vue&type=template&id=576a9746&"
import script from "./FieldTransRichText.vue?vue&type=script&lang=js&"
export * from "./FieldTransRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports